import { NgModule } from '@angular/core';
import { Routes, RouterModule } from "@angular/router";

import { RateYourExperienceComponent } from "./rate-your-experience/rate-your-experience.component";

import { BlankView } from "../views/blank/blank.view";

import { AuthGuardService } from 'app/services/auth.guard.service';


const supportTicketsRoutes: Routes = [
    //login view
    {

        path: 'support-tickets', component: BlankView,
        canActivate: [AuthGuardService],
        children: [
            { path: '', component: RateYourExperienceComponent },
            //handle all other routes
            { path: '**', component: RateYourExperienceComponent }
        ],
    },
    {
        path: 'rate-your-experience', component: BlankView,
        canActivate: [AuthGuardService],
        children: [
            { path: ':memberID:ticketID', component: RateYourExperienceComponent },
            { path: '**', component: RateYourExperienceComponent }
        ]
    },
];


@NgModule({
    imports: [RouterModule.forChild(supportTicketsRoutes)],
    exports: [RouterModule]
})
export class supportTicketsRoutingModule { }